export const deviceListData = [{
  "name":"DrTrust 521 - Smart body composition scale",
  "description": "A smart weighing scale that provides you with over 14 different weight parameters that goes beyond your weight.",
  "productId":"scale521",
  "productSkuId":"scale521",
  "productImageUrl":"https://statici.s3.ap-south-1.amazonaws.com/scale.png"
}, {
  "name":"DrTrust - iCheck Connect BP Monitor 118",
  "description": "A premium and portable smart BP monitor that provides you with accurate readings.",
  "productId":"bpMonitor118",
  "productSkuId":"bpMonitor118",
  "productImageUrl":"https://statici.s3.ap-south-1.amazonaws.com/bp.png"
}, {
  "name":"DrTrust GlucoSMART 9004 with 25 strips",
  "description": "A lightweight device that can be carried anywhere, anytime to manage, record, analyze all your sugar levels hassle-free.",
  "productId":"glucoSmart9004",
  "productSkuId":"glucoSmart9004",
  "productImageUrl":"https://statici.s3.ap-south-1.amazonaws.com/gluco.png"
}, {
  "name":"DrTrust - Healthpal smart watch 8002",
  "description": "Keep a watch on your vitals. It helps you to record all your real time health data - SpO2, BP, Heart Rate, and much more",
  "productId":"smartWatch8002",
  "productSkuId":"smartWatch8002",
  "productImageUrl":"https://statici.s3.ap-south-1.amazonaws.com/watch.png"
}];

export const dietPlans = [{
  dietPlanType: 'one_month_smart_diet_plan',
  duration: 1,
  price: 599,
  salePrice: 'Free',
  numberOfDevice: 0,
  deviceWorth: 0,
  personalCalls: 0,
  label: '1 month smart diet plan',
  specialLabel: 'Introductory offer'
}, {
  dietPlanType: 'one_month_diet_plan',
  duration: 1,
  price: 6200,
  salePrice: 2999,
  numberOfDevice: 1,
  deviceWorth: 4990,
  personalCalls: 2,
  label: '1 month + 1 DrTrust Smart Device'
}, {
  dietPlanType: 'three_month_diet_plan',
  duration: 3,
  price: 18600,
  salePrice: 7999,
  numberOfDevice: 2,
  deviceWorth: 11989,
  personalCalls: 6,
  label: '3 months + 2 DrTrust Smart Devices',
  specialLabel: 'Best value'
}, {
  dietPlanType: 'six_month_diet_plan',
  duration: 6,
  price: 37200,
  salePrice: 13999,
  numberOfDevice: 3,
  deviceWorth: 14399,
  personalCalls: 12,
  label: '6 months + 3 DrTrust Smart Devices'
}];

export const healthConditions = [{
    "label": "Diabetes",
    "value": "diabetes",
    "isChecked":false
  }, {
    "label": "Hypertension",
    "value": "hypertension",
    "isChecked":false
  }, {
    "label": "Overweight/ Obesity",
    "value": "overweight_and_obesity",
    "isChecked":false
  }, {
    "label": "PCOD",
    "value": "polycystic_ovarian_syndrome_disease",
    "isChecked":false
  }, {
    "label": "Thyroid",
    "value": "thyroid",
    "isChecked":false
  }, {
    "label": "None",
    "value": "none",
    "isChecked":false
  }, {
    "label": "Other",
    "value": "other",
    "isChecked":false
  }];

export const planType = [{
    "label": "Weight Loss Plan",
    "value": "weight_loss"
  },{
    "label": "Pre diabetes Plan",
    "value": "pre_diabetes"
  }, {
    "label": "Diabetes Management Plan",
    "value": "diabetes"
  }, {
    "label": "PCOD Management Plan",
    "value": "pcod"
  }, {
    "label": "Thyroid Management Plan",
    "value": "thyroid"
  }, {
    "label": "Hypertension Management Plan",
    "value": "hypertension"
  }, {
    "label": "Muscle Gain Plan",
    "value": "muscle_gain"
  }];


  export const allergiesType = [{
    "label": "Dairy Allergies",
    "value": "Milk",
    "isChecked":false
  },{
    "label": "Egg Allergies",
    "value": "Eggs",
    "isChecked":false
  },{
    "label": "Nut Allergies",
    "value": "Nuts",
    "isChecked":false
  },{
    "label": "Soya Allergies",
    "value": "Soya",
    "isChecked":false
  },{
    "label": "Wheat Allergies",
    "value": "Wheat",
    "isChecked":false
  },
  {
    "label": "None",
    "value": "None",
    "isChecked":false
  }];

export const dietaryPreference = [{
  "label": "Vegetarian",
  "value": "veg"
}, {
  "label": "Non-vegetarian",
  "value": "non_veg"
}, {
  "label": "Customise my plan",
  "value": "customise"
}];

export const dietaryPreferenceWithout = [{
  "label": "Vegetarian",
  "value": "veg"
}, {
  "label": "Non-vegetarian",
  "value": "non_veg"
}];

export const preferredCuisine = [{
  "label": "North - Indian",
  "value": "north_indian"
}, {
  "label": "South - Indian",
  "value": "south_indian"
}, {
  "label": "Customise my plan",
  "value": "customise"
}];

export const preferredCuisineWithout = [{
  "label": "North - Indian",
  "value": "north_indian"
}, {
  "label": "South - Indian",
  "value": "south_indian"
}];

export const questionradioOption = [{
  "label": "No",
  "value": "no"
}, {
  "label": "Yes",
  "value": "yes"
}]

export const riskAssessmentQuestions = [{
  name: 'userDetails',
  btnText: 'Begin test',
  title: 'Diabetic risk score',
  footerText: 'The older you are, the higher your risk is for type 2 diabetes'
}, {
  name: 'diabetes',
  btnText: 'Next',
  title: 'Do you have any family history for diabetes?',
  footerText: 'A family history of diabetes could contribute to your risk for type 2 diabetes'
}, {
  name: 'bloodPressure',
  btnText: 'Next',
  title: 'Have you ever been diagnosed with high blood pressure?',
  footerText: 'Having high blood pressure contributes to your overall risk for type 2 diabetes.'
}, {
  name: 'physicallyActive',
  btnText: 'Next',
  title: 'Are you physically active?',
  footerText: 'Being inactive can increase your risk for type 2 diabetes.'
}, {
  name: 'currentHeightWeight',
  btnText: 'Submit',
  title: 'Your Body mass index (BMI)'
}]

export const riskAssessmentQuestionOption = [{
	"label": "No",
  "value": "no"
}, {
	"label": "Yes",
	"value": "yes"
}]

export const questionerResponse = [{
  "questionerOrder": 1,
  "questionerType": "single",
  "questionerLabel": "gestational_diabetes",
  "questionerText": "Have you ever been diagnosed with gestational diabetes?",
  "responseText": '',
  "scoreOfResponse": 7
},{
  "questionerOrder": 2,
  "questionerType": "single",
  "questionerLabel": "family_diabieties_history",
  "questionerText": "Do you have any family history for diabetes?",
  "responseText": '',
  "scoreOfResponse": 7
},{
  "questionerOrder": 3,
  "questionerType": "single",
  "questionerLabel": "high_blood_pressure",
  "questionerText": "Have you ever been diagnosed with high blood pressure?",
  "responseText": '',
  "scoreOfResponse": 7
},{
  "questionerOrder": 4,
  "questionerType": "single",
  "questionerLabel": "physically_active",
  "questionerText": "Are you physically active?",
  "responseText": '',
  "scoreOfResponse": 7
}];

export const QUESTIONS = [{
  id: 1,
  title: 'Do you take any Medications',
  name: 'medication',
  isSingle: true,
  options: [{
    label: 'Yes',
    value: 'yes'
  }, {
    label: 'No',
    value: 'no'
  }]
}, {
  id: 2,
  title: 'Do you have any allergies',
  name: 'allergies',
  options: [{
    label: 'Shell fish',
    value: 'Shell fish'
  }, {
    label: 'Eggs',
    value: 'Eggs'
  }, {
    label: 'Peanuts',
    value: 'Peanuts'
  }, {
    label: 'Gluten',
    value: 'Gluten'
  }, {
    label: 'Lactose',
    value: 'Lactose'
  }, {
    label: 'Fish',
    value: 'Fish'
  }, {
    label: 'Mushroom',
    value: 'Mushroom'
  }, {
    label: 'Soy',
    value: 'Soy'
  }, {
    label: 'Nuts (pistachio, almonds, cashew nut, walnut)',
    value: 'Nuts (pistachio, almonds, cashew nut, walnut)'
  }, {
    label: 'Milk',
    value: 'Milk'
  }, {
    label: 'None',
    value: 'none'
  }, {
    label: 'Other',
    value: 'Other'
  }]
}, {
  id: 3,
  title: 'Do you have any of the following past or existing health conditions',
  name: 'healthConditions',
  options: [{
    label: 'Diabetes',
    value: 'diabetes'
  }, {
    label: 'Hypertension',
    value: 'hypertension'
  }, {
    label: 'Hypotension',
    value: 'hypotension'
  }, {
    label: 'Overweight/ Obesity',
    value: 'overweight_and_obesity'
  }, {
    label: 'PCOD',
    value: 'polycystic_ovarian_syndrome_disease'
  }, {
    label: 'Thyroid',
    value: 'thyroid'
  }, {
    label: 'High Cholesterol',
    value: 'high_cholesterol'
  }, {
    label: 'None',
    value: 'none'
  }, {
    label: 'Others',
    value: 'others'
  }]
}, {
  id: 4,
  title: 'Choose a plan that will help you to achieve your health goals',
  name: 'healthGoals',
  options: [{
    label: 'Weight Loss',
    value: 'weight_loss'
  }, {
    label: 'Muscle Gain',
    value: 'muscle_gain'
  }, {
    label: 'Diabetes management',
    value: 'diabetes_management'
  }, {
    label: 'Hypertension Management',
    value: 'hypertension_management'
  }, {
    label: 'Thyroid Management',
    value: 'thyroid_management'
  }, {
    label: 'PCOD Management',
    value: 'pcod_management'
  }, {
    label: 'Holistic Healthy Diet',
    value: 'holistic_healthy_diet'
  }, {
    label: 'Other',
    value: 'other'
  }]
}, {
  id: 5,
  title: 'Select your dietary preference',
  name: 'dietaryPreference',
  options: [{
    label: 'Vegetarian',
    value: 'Vegetarian'
  }, {
    label: 'Non Vegetarian',
    value: 'Non Vegetarian'
  }, {
    label: 'Eggetarian',
    value: 'Eggetarian'
  }, {
    label: 'Pescatarian',
    value: 'Pescatarian'
  }, {
    label: 'Vegan',
    value: 'Vegan'
  }, {
    label: 'Other',
    value: 'other'
  }]
}, {
  id: 6,
  title: 'Select your preferred cuisine',
  name: 'preferredCuisine',
  options: [{
    label: 'North Indian',
    value: 'North Indian'
  }, {
    label: 'South Indian',
    value: 'South Indian'
  }, {
    label: 'Maharashtrian',
    value: 'Maharashtrian'
  }, {
    label: 'Gujarati',
    value: 'Gujarati'
  }, {
    label: 'Bengali',
    value: 'Bengali'
  }, {
    label: 'Rajasthani',
    value: 'Rajasthani'
  }, {
    label: 'Continental',
    value: 'Continental'
  }, {
    label: 'Asian',
    value: 'Asian'
  }, {
    label: 'Mexican',
    value: 'Mexican'
  }, {
    label: 'Italian',
    value: 'Italian'
  }, {
    label: 'Other',
    value: 'Other'
  }]
}]

export const healthConditionsDuplicate = [{
  "heathConditionLabel": "Diabetes",
  "heathConditionValue": "diabetes"
}, {
  "heathConditionLabel": "Hypertension",
  "heathConditionValue": "hypertension"
}, {
  "heathConditionLabel": "Hypotension",
  "heathConditionValue": "hypotension"
}, {
  "heathConditionLabel": "Overweight/ Obesity",
  "heathConditionValue": "overweight_and_obesity"
}, {
  "heathConditionLabel": "PCOD",
  "heathConditionValue": "polycystic_ovarian_syndrome_disease"
}, {
  "heathConditionLabel": "Thyroid",
  "heathConditionValue": "thyroid"
}, {
  "heathConditionLabel": "High Cholesterol",
  "heathConditionValue": "high_cholesterol"
}, {
  "heathConditionLabel": "None",
  "heathConditionValue": "none"
}, {
  "heathConditionLabel": "Others",
  "heathConditionValue": "others"
}]
